<template>
  <!-- 裁判所情報入力補助 -->
  <ModalDialog
    pop-name="裁判所情報入力補助"
    dialog-width="500px"
    dialog-height="333px"
    @close="closeModal"
  >
    <template #body>
      <div ref="wrapper" class="fd__wrapper">
        <div class="fd__list">
          <div id="recordWindows" class="">
            <Input
              v-if="filterCheck"
              id="filterTextBox"
              v-model="filterString"
              class="form-control a"
              type="text"
              placeholder="Filter..."
              @input="change($event)"
              @focus="oninputfocus"
            />
            <div v-else class="d-flex col-12">
              <div class="col-11">
                <span
                  v-for="(item1, index1) in valueadd"
                  :key="index1"
                  class="badge b-form-tag d-inline-flex align-items-baseline mw-100 mr-1 badge-secondary"
                >
                  <span class="b-form-tag-content flex-grow-1 text-truncate">{{
                    item1.name
                  }}</span>
                  <button
                    aria-keyshortcuts="Delete"
                    type="button"
                    aria-label="Remove tag"
                    class="close b-form-tag-remove"
                    @click="onremoveCurt(index1)"
                  >
                    ×
                  </button>
                </span>
              </div>
              <button
                aria-keyshortcuts="Delete"
                type="button"
                aria-label="Remove tag"
                class="closeall b-form-tag-remove col-1"
                @click="onremoveCurtAll()"
              >
                ×
              </button>
            </div>
          </div>
          <ul v-if="listShow">
            <li
              v-for="(item, index) in filteredItems"
              :key="index"
              class="fd__item d-flex align-items-center"
            >
              <input
                id="flexCheckDefault"
                v-model="item.isTrue"
                class="form-check-input me-1"
                style="margin-top: 0"
                type="checkbox"
                @change="chkClick"
              />
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </template>

    <template #footer> </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'CourtEntryAssistanceDialog',
  props: {
    items: Array
  },
  data() {
    return {
      listShow: false,
      filterCheck: true,
      filterString: null,
      filterString1: '',
      showList: false,
      selectedValue: '',
      showEmptyItem: 'true',
      disabled: 'false',
      ignoreCase: 'true',

      emptyItemValue: 'SAMPLE_EMPTY_VALUE',
      emptyItemText: '',
      placeholder: 'Please select...',
      name: 'fruit',
      idKey: 'id',
      valueKey: 'name',
      textKey: 'name',
      filterTargetKey: 'name',

      valueadd: []
    }
  },
  computed: {
    filteredItems() {
      if (!this.filterString) return this.items
      if (!this.items || this.items.length === 0) return []
      const flags = this.ignoreCase ? 'i' : ''

      const regexp = new RegExp(this.filterString, flags)
      return this.items.filter(x => {
        const targetValue = this.filterTargetKey
          ? x[this.filterTargetKey]
          : JSON.stringify(x)
        return regexp.test(targetValue)
      })
    }
  },
  watch: {
    valueadd1(e) {
      console.log(e)
    }
  },
  mounted() {
    this.oninputBlur()
    $('#recordWindows').show()
  },
  methods: {
    change(e) {
      this.filterString = e.target.value
    },
    closeModal() {
      this.$emit('close', this.valueadd)
      this.filterCheck = true
    },

    chkClick() {
      this.valueadd = this.filteredItems.filter(item => item.isTrue === true)
      if (this.valueadd.length === 0) {
        this.filterCheck = true
      } else {
        this.filterCheck = false
      }
    },
    oninputfocus() {
      console.log(this.valueadd.length)
      this.listShow = true
      this.filterCheck = true
    },
    oninputBlur() {
      this.listShow = false
    },
    onremoveCurt(index1) {
      this.valueadd[index1].isTrue = false
      this.valueadd = this.filteredItems.filter(item => item.isTrue === true)
      if (this.valueadd.length === 0) {
        this.filterCheck = true
      }
    },
    onremoveCurtAll() {
      this.valueadd = []
      this.filterCheck = true
      this.valueadd = this.filteredItems.forEach(item => {
        item.isTrue = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
#recordWindows {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}
:hover.link {
  color: RGBA(50, 102, 222, 0.7);
}
#filterTextBox {
  border: none;
}

.fd__wrapper {
  position: relative;
  width: 100%;
  .badge {
    color: rgb(83, 83, 83);
    font-size: 16px;
    .text-truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .close {
      border: 0;
    }
  }
  .closeall {
    border: 0;
  }
  * {
    font-size: 1rem;
  }
  input.fd__display-textbox,
  input.fd__filter-textbox {
    width: 100%;
  }
  .fd__list {
    z-index: 1 !important;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 4px;
    border: solid 1px rgb(192, 192, 192);
    background: white;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
    margin-top: -1px;
    ul {
      margin: 4px 0 0 0;
      padding: 4px;
      overflow-x: auto;
      overflow-y: scroll;
      max-height: 40vh;
      li {
        padding: 4px 1px;
        cursor: pointer;
        list-style: none;
        line-height: 1;
        &.fd__item:hover {
          background: aliceblue;
        }
      }
    }
  }
}
</style>
